import React from "react";

function UMKMD() {
  return (
    <div className="UMKMD-container">
      <section className="UMKMD-upperSection">
        <img src="http://via.placeholder.com/300" alt="" />
        <div className="UMKMD-profilUMKM">
          <h1>Nama UMKM</h1>
          <table>
            <tr>
              <td>Nomer Hp</td>
              <td>:</td>
              <td>08512345678</td>
            </tr>
            <tr>
              <td>Alamat</td>
              <td>:</td>
              <td>Bandung, Jawa Barat</td>
            </tr>
            <tr>
              <td>E-Commerce</td>
              <td>:</td>
              <td>http://linktokonyanantidisini</td>
            </tr>
            <tr>
              <td>Instagram</td>
              <td>:</td>
              <td>Link Sosmednya nanti disini</td>
            </tr>
          </table>
        </div>
      </section>
      <hr />
      <section className="UMKMD-lowerSection">
        <div className="UMKMD-cardRow">
          <div className="UMKMD-card">
            <img src="http://via.placeholder.com/200" alt="" />
            <div className="UMKMD-cardInfo">
              <h2>Nama Barang</h2>
              <p>Deskripsi Barang</p>
            </div>
          </div>

          <div className="UMKMD-card">
            <img src="http://via.placeholder.com/200" alt="" />
            <div className="UMKMD-cardInfo">
              <h2>Nama Barang</h2>
              <p>Deskripsi Barang</p>
            </div>
          </div>

          <div className="UMKMD-card">
            <img src="http://via.placeholder.com/200" alt="" />
            <div className="UMKMD-cardInfo">
              <h2>Nama Barang</h2>
              <p>Deskripsi Barang</p>
            </div>
          </div>
        </div>

        <div className="UMKMD-cardRow">
          <div className="UMKMD-card">
            <img src="http://via.placeholder.com/200" alt="" />
            <div className="UMKMD-cardInfo">
              <h2>Nama Barang</h2>
              <p>Deskripsi Barang</p>
            </div>
          </div>

          <div className="UMKMD-card">
            <img src="http://via.placeholder.com/200" alt="" />
            <div className="UMKMD-cardInfo">
              <h2>Nama Barang</h2>
              <p>Deskripsi Barang</p>
            </div>
          </div>

          <div className="UMKMD-card">
            <img src="http://via.placeholder.com/200" alt="" />
            <div className="UMKMD-cardInfo">
              <h2>Nama Barang</h2>
              <p>Deskripsi Barang</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default UMKMD;
